exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-container[data-v-e10d0cc8] {\n  max-width: 250px;\n}\n", ""]);

// exports
